export default "__VITE_ASSET__dIhCvhQb__"